import { render, staticRenderFns } from "./combat_groupStage.vue?vue&type=template&id=49fdb556&scoped=true"
import script from "./combat_groupStage.vue?vue&type=script&lang=js"
export * from "./combat_groupStage.vue?vue&type=script&lang=js"
import style0 from "./combat_groupStage.vue?vue&type=style&index=0&id=49fdb556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fdb556",
  null
  
)

export default component.exports